
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3ebd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3ebd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("04iQo", function(module, exports) {

$parcel$export(module.exports, "darkMode", () => $00cefde3a1e875c9$export$808aaf1b460dc9af);
// //     // On page load or when changing themes, best to add inline in `head` to avoid FOUC
//     export const darkMode= function(){
//         if (localStorage.getItem('color-theme') === 'dark' || (!('color-theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
//             document.documentElement.classList.add('dark');
//         } else {
//             document.documentElement.classList.remove('dark')
//         }
//         let themeToggleDarkIcon = document.querySelector('.theme-toggle-dark-icon');
//         let themeToggleLightIcon = document.querySelector('.theme-toggle-light-icon');
// // Change the icons inside the button based on previous settings
// if (localStorage.getItem('color-theme') === 'dark' || (!('color-theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
//     themeToggleLightIcon.classList.remove('hidden');
// } else {
//     themeToggleDarkIcon.classList.remove('hidden');
// }
// let themeToggleBtn = document.getElementById('theme-toggle');
// themeToggleBtn.addEventListener('click', function() {
//     // toggle icons inside button
//     themeToggleDarkIcon.classList.toggle('hidden');
//     themeToggleLightIcon.classList.toggle('hidden');
//     // if set via local storage previously
//     if (localStorage.getItem('color-theme')) {
//         if (localStorage.getItem('color-theme') === 'light') {
//             document.documentElement.classList.add('dark');
//             localStorage.setItem('color-theme', 'dark');
//         } else {
//             document.documentElement.classList.remove('dark');
//             localStorage.setItem('color-theme', 'light');
//         }
//     // if NOT set via local storage previously
//     } else {
//         if (document.documentElement.classList.contains('dark')) {
//             document.documentElement.classList.remove('dark');
//             localStorage.setItem('color-theme', 'light');
//         } else {
//             document.documentElement.classList.add('dark');
//             localStorage.setItem('color-theme', 'dark');
//         }
//     }
// });
//     }
const $00cefde3a1e875c9$export$808aaf1b460dc9af = function() {
    if (localStorage.getItem("color-theme") === "light" || !("color-theme" in localStorage) && !window.matchMedia("(prefers-color-scheme: dark)").matches) document.documentElement.classList.remove("dark");
    else document.documentElement.classList.add("dark");
    let themeToggleDarkIcon = document.querySelector(".theme-toggle-dark-icon");
    let themeToggleLightIcon = document.querySelector(".theme-toggle-light-icon");
    // Change the icons inside the button based on previous settings
    if (localStorage.getItem("color-theme") === "light" || !("color-theme" in localStorage) && !window.matchMedia("(prefers-color-scheme: dark)").matches) themeToggleDarkIcon.classList.remove("hidden");
    else themeToggleLightIcon.classList.remove("hidden");
    let themeToggleBtn = document.getElementById("theme-toggle");
    themeToggleBtn.addEventListener("click", function() {
        // toggle icons inside button
        themeToggleDarkIcon.classList.toggle("hidden");
        themeToggleLightIcon.classList.toggle("hidden");
        // if set via local storage previously
        if (localStorage.getItem("color-theme")) {
            if (localStorage.getItem("color-theme") === "light") {
                document.documentElement.classList.add("dark");
                localStorage.setItem("color-theme", "dark");
            } else {
                document.documentElement.classList.remove("dark");
                localStorage.setItem("color-theme", "light");
            }
        } else if (document.documentElement.classList.contains("dark")) {
            document.documentElement.classList.remove("dark");
            localStorage.setItem("color-theme", "light");
        } else {
            document.documentElement.classList.add("dark");
            localStorage.setItem("color-theme", "dark");
        }
    });
};

});

const $0ac4364b747937d6$export$a9861bd62f48e142 = "d2d9025e7f101b3c88abb61fdaf46a27";
const $0ac4364b747937d6$export$e267413983b03500 = "https://image.tmdb.org/t/p/";
const $0ac4364b747937d6$export$454851eb626f6abe = "https://api.themoviedb.org/3";
const $0ac4364b747937d6$export$363934e2a429e3fc = function(queryOption, query) {
    return `${$0ac4364b747937d6$export$454851eb626f6abe}/${query}/${queryOption}?api_key=${$0ac4364b747937d6$export$a9861bd62f48e142}&region=BE&language=en-US&page=1`;
} // https://api.themoviedb.org/3/trending/person/day?api_key=YOUR_API_KEY'
;


//fetch data 
const $3a1ffdd68feb4087$export$d047a7c56db64af4 = async function(url) {
    try {
        // const resp=await Promise.race([fetch(url),timeout(TIMEOUT_SEC)]);//over 5s timeout fires
        const resp = await fetch(url);
        const data = await resp.json();
        if (!resp.ok) throw new Error(`${data.message} ; ${data.status}`);
        return data;
    } catch (err) {
        throw err;
    }
};
const $3a1ffdd68feb4087$export$566cbef952e6c145 = function(obj, newData) {
    for(let key in obj)if (obj.hasOwnProperty(key)) delete obj[key];
    for(let key in obj)if (newData.hasOwnProperty(key)) obj[key] = newData[key];
    return obj;
};
const $3a1ffdd68feb4087$export$998191bfdf710c72 = function(element) {
    element.classList.remove("hidden");
    element.classList.add("block");
};
const $3a1ffdd68feb4087$export$7669482c90f5c50f = function(element) {
    element.classList.remove("block");
    element.classList.add("hidden");
};
const $3a1ffdd68feb4087$export$2353115f31f4d15 = function(elementToScrollTo) {
    elementToScrollTo.scrollIntoView({
        behavior: "smooth"
    });
};
const $3a1ffdd68feb4087$export$17c5814fb0e2ce7f = function(domainName) {
    if (typeof domainName !== "string") return;
    window.open(domainName, "_blank");
};
const $3a1ffdd68feb4087$export$371e338370561054 = function(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};
const $3a1ffdd68feb4087$export$a3345e786522dfb4 = function(formId) {
    const form = document.getElementById(formId);
    const user = form.getElementsByTagName("input");
    const deviceInfor = form.getElementsByTagName("select");
    return [
        ...user,
        ...deviceInfor
    ];
};
const $3a1ffdd68feb4087$export$dd1bc94b04021eeb = function(value) {
    if (value === null || value === undefined) return true;
    if (typeof value === "string" && value.trim() === "") return true;
    if (Array.isArray(value) && value.length === 0) return true;
    if (typeof value === "object" && Object.keys(value).length === 0) return true;
    return false;
};


let $6e0c6fdb7e857166$export$ca000e230c0caa3e = {
    movie: {
        top_rated: [],
        popular: []
    },
    tv: {
        top_rated: [],
        popular: []
    }
};
const $6e0c6fdb7e857166$export$f0d975943c2b7900 = async function(queryOption, query) {
    try {
        const data = await (0, $3a1ffdd68feb4087$export$d047a7c56db64af4)((0, $0ac4364b747937d6$export$363934e2a429e3fc)(queryOption, query));
        const { results: results } = data;
        //store the data in the required attribute in the state 
        $6e0c6fdb7e857166$export$ca000e230c0caa3e[`${query}`][`${queryOption}`] = [
            ...results
        ]; //array of objects.
    } catch (error) {
        throw error;
    }
};




class $1ccdc12a466496f8$var$popularMoviesView {
    _data;
    _parentEl = document.querySelector("#popular");
    _dropDownListItems = document.querySelector(".dropDown.popular");
    render(data) {
        const markup = this._generateMarkup(data);
        this._clear();
        this._parentEl.insertAdjacentHTML("afterbegin", markup);
    }
    _clear() {
        this._parentEl.innerHTML = "";
    }
    addHandlerToBtnResult(handler) {
        this._dropDownListItems.addEventListener("click", (event)=>{
            event.preventDefault();
            handler(event);
        });
    }
    _generateMarkup(data) {
        return data.map((result)=>{
            return `  
      <div   class="swiper-slide popularSwiper relative cursor-pointer"
                data-id=" ${result.id}"
                data-title="${result.title || result.name}" 
                data-overview="${result.overview}"
                data-poster="${result.poster_path}"
                data-backdrop="${result.backdrop_path}"
                > 
      <img src="${0, $0ac4364b747937d6$export$e267413983b03500}/w500/${result.poster_path}" class="block rounded"/> 
    
      </div>
    `;
        }).join("");
    }
}
var $1ccdc12a466496f8$export$2e2bcd8739ae039 = new $1ccdc12a466496f8$var$popularMoviesView();



var $04iQo = parcelRequire("04iQo");
let $6f9865c1659aa33e$export$34cb4889b4dd2cb1 = new Swiper(".mySwiper", {
    spaceBetween: 5,
    slidesPerView: 4,
    autoplay: {
        delay: 3500,
        disableOnInteraction: false
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    },
    breakpoints: {
        320: {
            slidesPerView: 2
        },
        580: {
            slidesPerView: 3
        },
        768: {
            slidesPerView: 4
        },
        1024: {
            slidesPerView: 6
        }
    }
});


let $c27ff4b6154b0429$export$1ae4d659ee2887ed = new Swiper(".swiperReview", {
    spaceBetween: 10,
    autoplay: {
        delay: 2500,
        disableOnInteraction: false
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    },
    breakpoints: {
        320: {
            slidesPerView: 2
        },
        640: {
            slidesPerView: 3
        },
        800: {
            slidesPerView: 4
        },
        1024: {
            slidesPerView: 5
        }
    }
});


const $f709aef2086bc5d1$var$containers = document.querySelectorAll(".x-scroll-el");
const $f709aef2086bc5d1$var$scrollSpeed = 1;
let $f709aef2086bc5d1$var$scrollAmount = 0;
const $f709aef2086bc5d1$export$8fb8b3162949d3aa = ()=>{
    $f709aef2086bc5d1$var$scrollAmount += $f709aef2086bc5d1$var$scrollSpeed;
    $f709aef2086bc5d1$var$containers.forEach((container)=>{
        container.scrollLeft = $f709aef2086bc5d1$var$scrollAmount;
        if ($f709aef2086bc5d1$var$scrollAmount >= container.scrollWidth / 2) $f709aef2086bc5d1$var$scrollAmount = 0;
    });
};


const $3cc3152e78abcee7$var$handleScoreAnim = function(el, targetScore) {
    let currentScore = 0;
    const duration = 2000;
    let intervalDuration = 10;
    let increment = targetScore / (duration / intervalDuration);
    const inceaseScores = setInterval(()=>{
        currentScore += increment;
        el.textContent = `${Math.floor(currentScore)}`;
        if (currentScore === targetScore) clearInterval(inceaseScores);
    }, intervalDuration);
};
const $3cc3152e78abcee7$var$scoreSection = document.getElementById("scores");
const $3cc3152e78abcee7$export$cde704f54995a52 = function() {
    let observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                $3cc3152e78abcee7$var$handleScoreAnim(document.getElementById("active-users_count"), 400);
                $3cc3152e78abcee7$var$handleScoreAnim(document.getElementById("sport-channels_count"), 2000);
                $3cc3152e78abcee7$var$handleScoreAnim(document.getElementById("channels_count"), 21000);
                $3cc3152e78abcee7$var$handleScoreAnim(document.getElementById("movies_count"), 160000);
                observer.disconnect();
            }
        });
    });
    observer.observe($3cc3152e78abcee7$var$scoreSection);
};


document.addEventListener("DOMContentLoaded", function() {
    $647be9e9e843caef$var$loadResults();
    (0, $04iQo.darkMode)();
});
//         // Function to update the content of the <p> element
//         function updateContent() {
//             // Get the <p> element by its id
//             var paragraph = document.getElementById("dynamicText");
//             console.log(paragraph)
//             // Array of different content to cycle through
//             var contentArray = [
//                 "2 devices - 1 year Plan <span class='text-lg text-red md:text-xl'>+ 6 </span><span class='text-red'>months extra</span>",
//                 "1 year Plan <span class='text-lg text-red md:text-xl'>+ 3 <span class='text-red'>months extra</span>",
//                 "6 months Plan <span class='text-lg text-red md:text-xl'>+ 1 <span class='text-red'>month extra</span>"
//                 // Add more content as needed
//             ];
//             // Get a random index from the array
//             var randomIndex = Math.floor(Math.random() * contentArray.length);
//             // Update the content of the <p> element
//             paragraph.innerHTML = contentArray[randomIndex];
//         }
//         // Set up an interval to call the updateContent function every 5 seconds (5000 milliseconds)
//         setInterval(updateContent, 4000);
// // Set the date we're counting down to
// var countDownDate = new Date("jan 16, 2024 00:00:00").getTime();
// // Update the count down every 1 second
// var x = setInterval(function() {
// // Get today's date and time
// var now = new Date().getTime();
// // Find the distance between now and the count down date
// var distance = countDownDate - now;
// // Time calculations for days, hours, minutes and seconds
// var days = Math.floor(distance / (1000 * 60 * 60 * 24));
// var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
// var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
// var seconds = Math.floor((distance % (1000 * 60)) / 1000);
// // Display the result in the element with id="demo"
// document.getElementById("demo").innerHTML = days + "d " + hours + "h "
// + minutes + "m " + seconds + "s ";
// // If the count down is finished, write some text
// if (distance < 0) {
// clearInterval(x);
// document.getElementById("demo").innerHTML = "EXPIRED";
// }
// }, 1000);
// make pricing link blue when intersect with pricing section???????
const $647be9e9e843caef$var$pricingSection = document.getElementById("pricing");
const $647be9e9e843caef$var$pricingLink = document.getElementById("pricing-link");
const $647be9e9e843caef$var$changeLinkColorInter = function(targetEl, linkEl) {
    let observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                console.log(linkEl);
                linkEl.classList.remove("text-gray-900");
                linkEl.classList.add("text-blue-500");
                console.log("is intersect");
            } else console.log("not intersect");
        });
    });
    observer.observe(targetEl);
};
$647be9e9e843caef$var$changeLinkColorInter($647be9e9e843caef$var$pricingSection, $647be9e9e843caef$var$pricingLink);
// ?????????????????????????????????????????????????????????
const $647be9e9e843caef$var$loadResults = async function() {
    try {
        await $6e0c6fdb7e857166$export$f0d975943c2b7900("popular", "movie");
        (0, $1ccdc12a466496f8$export$2e2bcd8739ae039).render($6e0c6fdb7e857166$export$ca000e230c0caa3e.movie.popular);
    } catch (err) {
        console.log(err);
    }
};
const $647be9e9e843caef$var$clickDrophandler = async function(e) {
    e.stopImmediatePropagation();
    const target = e.target;
    console.log("trending");
    //change dropdown's text
    const targetdrop = target.closest(".dropDown");
    targetdrop.previousElementSibling.firstElementChild.textContent = target.textContent;
    //GET QUERY.
    const queryObj = JSON.parse(target.getAttribute("data-query"));
    console.log("query Object", queryObj);
    const { query: query, queryOption: queryOption } = queryObj;
    //render new data.
    if (!targetdrop.classList.contains("popular")) return;
    await $6e0c6fdb7e857166$export$f0d975943c2b7900(queryOption, query);
    (0, $1ccdc12a466496f8$export$2e2bcd8739ae039).render($6e0c6fdb7e857166$export$ca000e230c0caa3e[`${query}`][`${queryOption}`]);
};
(0, $1ccdc12a466496f8$export$2e2bcd8739ae039).addHandlerToBtnResult($647be9e9e843caef$var$clickDrophandler);
//slide channels logo
setInterval((0, $f709aef2086bc5d1$export$8fb8b3162949d3aa), 10);
//scores animation 
(0, $3cc3152e78abcee7$export$cde704f54995a52)();
//language switch
const $647be9e9e843caef$var$lanDiv = document.querySelector(".switchLangDiv");
$647be9e9e843caef$var$lanDiv.addEventListener("click", (e)=>{
    const target = e.target;
    //1- toggle the language list when click
    if (target.closest(".currentLang")) {
        console.log("hi");
        const languageOptionsEl = target.closest(".currentLang").nextElementSibling;
        console.log(languageOptionsEl);
        if (languageOptionsEl.classList.contains("hidden")) {
            languageOptionsEl.classList.remove("hidden");
            languageOptionsEl.classList.add("flex");
        } else {
            languageOptionsEl.classList.add("hidden");
            languageOptionsEl.classList.remove("flex");
        }
    }
});
//switch between 01 device and 02 device plans 
const $647be9e9e843caef$var$planOptionsBtn = document.querySelectorAll(".plan-option-btn");
const $647be9e9e843caef$var$planOptions = document.querySelectorAll(".plan-option");
console.log($647be9e9e843caef$var$planOptions);
console.log($647be9e9e843caef$var$planOptionsBtn);
$647be9e9e843caef$var$planOptionsBtn.forEach((btn, index)=>{
    btn.addEventListener("click", (e)=>{
        console.log(index);
        $647be9e9e843caef$var$planOptionsBtn.forEach((btn)=>btn.classList.remove("active-tab"));
        btn.classList.add("active-tab");
        $647be9e9e843caef$var$planOptions.forEach((plan)=>plan.classList.add("hidden"));
        $647be9e9e843caef$var$planOptions[index].classList.remove("hidden");
    });
});
// Target date: November 30
const $647be9e9e843caef$var$targetDate = new Date("November 30, 2024 23:59:59").getTime();
function $647be9e9e843caef$var$updateCountdown() {
    const now = new Date().getTime();
    const timeLeft = $647be9e9e843caef$var$targetDate - now;
    if (timeLeft > 0) {
        const days = Math.floor(timeLeft / 86400000);
        const hours = Math.floor(timeLeft % 86400000 / 3600000);
        const minutes = Math.floor(timeLeft % 3600000 / 60000);
        const seconds = Math.floor(timeLeft % 60000 / 1000);
        document.getElementById("countdown").innerText = `${days}d ${hours}h ${minutes}m ${seconds}s`;
    } else {
        document.getElementById("countdown").innerText = "The countdown is over!";
        clearInterval($647be9e9e843caef$var$timer); // Stop the timer
    }
}
// Update the countdown every second
const $647be9e9e843caef$var$timer = setInterval($647be9e9e843caef$var$updateCountdown, 1000);
// Initial call to display the timer immediately
$647be9e9e843caef$var$updateCountdown();


//# sourceMappingURL=index.40b9ad1e.js.map
